module.exports = __webpack_public_path__ + "img/BE0426220671.f5aebd44.svg";